import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'; // Corrected import for TranslateHttpLoader
import { CommonModule } from '@angular/common'; // Import CommonModule

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SideBarComponent } from './core/components/side-bar/side-bar.component';

import { LoginModule } from './core/components/login/login.module';

import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AngularFireModule } from '@angular/fire/compat';
import {
  AngularFireAuth,
  AngularFireAuthModule,
} from '@angular/fire/compat/auth';
import {
  AngularFirestore,
  AngularFirestoreModule,
} from '@angular/fire/compat/firestore';
import { AngularFireFunctions } from '@angular/fire/compat/functions'; // Removed AngularFireFunctionsModule
import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/compat/storage';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon'; // Ensure MatIconModule is imported
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { IonicModule } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { AlertModule } from './shared/components/alert/alert.module';
import { ConfirmAlertModule } from './shared/components/confirm-alert/confirm-alert.module';
import { LoadingModule } from './shared/components/load/load.module';
// Removed explicit import for LoadingComponent
import { RouterModule } from '@angular/router'; // Explicitly import RouterModule

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

const userLocale = navigator.language || 'en-US';

@NgModule({
    declarations: [AppComponent, SideBarComponent], // Removed LoadingComponent from declarations
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatCardModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFirestoreModule,
        IonicModule.forRoot(),
        MatSnackBarModule,
        MatIconModule, // Ensure MatIconModule is here
        LoginModule,
        AlertModule,
        ConfirmAlertModule,
        LoadingModule,
        TranslateModule.forRoot({
            defaultLanguage: 'en-CA',
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        AngularFireStorageModule,
        RouterModule, // Added RouterModule
        CommonModule // Add CommonModule here
    ],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        provideNativeDateAdapter(),
        { provide: MAT_DATE_LOCALE, useValue: userLocale },
        AngularFireFunctions, // Provided AngularFireFunctions here
        AngularFireStorage // Provided AngularFireStorage here
    ],
})
export class AppModule {
  constructor(
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private functions: AngularFireFunctions,
    private storage: AngularFireStorage
  ) {
    if (environment.useEmulators) {
      this.firestore.firestore.settings({
        host: 'localhost:8089',
        ssl: false,
      });

      // Auth
      this.auth.useEmulator('http://localhost:9099/').then();

      // Functions
      this.functions.useEmulator('localhost', 5001).then();

      // Storage
      this.storage.storage.useEmulator('localhost', 9199);
    }
  }
}
